import { render, staticRenderFns } from "./MypageAboutUsingPane.vue?vue&type=template&id=0509097c&scoped=true"
import script from "./MypageAboutUsingPane.vue?vue&type=script&lang=ts"
export * from "./MypageAboutUsingPane.vue?vue&type=script&lang=ts"
import style0 from "./MypageAboutUsingPane.vue?vue&type=style&index=0&id=0509097c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0509097c",
  null
  
)

export default component.exports